<template>
  <div class="c-app" :class="{ 'c-dark-theme': darkMode }">
    <!-- <component :is="'script'" type="module" src="https://js.stripe.com/v3/" async></component> -->
    <!-- <Sidebar /> -->
    <CWrapper>
      <Header />
        <div class="c-body">
            <main class="c-main p-0">
                <child />
            </main>
        </div>
      <Footer />
    </CWrapper>
  </div>
</template>

<script>
import Sidebar from "£lement/sidebar";
import Header from "£lement/header";
import Footer from "£lement/footer";
import { mapGetters } from "vuex";

export default {
    name: "MainLayout",

    components: {
        Sidebar,
        Header,
        Footer
    },

    computed: {
        ...mapGetters({
            darkMode: "panel/darkMode"
        })
    },
    data () {
        return {
            fixedToasts: 0,
            
        }
    },
    methods:{
        initScript(src){
            this.$loadScript(src)
            .then(() => {
                console.log("Script loaded");
            })
            .catch(() => {
                console.log("Script failed");
            });
        }
    },
    mounted(){
        /* this.initScript('https://js.stripe.com/v3/'); */
    }
    
};
</script>
<style scoped lang="scss">
    .container-fluid{
        padding: 0;
    }
</style>
